<template>
  <div
    class="flux-header"
    @contextmenu.prevent.stop="handleClick($event, flux)"
    
  >
    <div class="flux-name">
      <span class="flux-name-description">{{flux.description.toUpperCase()}}</span>

      <div
        v-if="isUserThalesAdmin()"
        class="flux-edit-icon"
        @click.prevent.stop="showEditLoopModal(flux)"
      >
        <i class="fa fa-pencil"></i>
      </div>
    </div>
    <div>
      <span class="minMax">min: {{fluxData[selected].minLeadTime ? fluxData[selected].minLeadTime:'--'  }}</span>
      <span class="avg-lead-time">Lead Time : {{ fluxData[selected].leadTimeAvg ? fluxData[selected].leadTimeAvg : ' --'}}</span>
      <span class="minMax">max: {{ fluxData[selected].maxLeadTime ? fluxData[selected].maxLeadTime : ' --' }} </span>
    </div>
    <div class='ml-lg-auto stats-choice'>
      <b-form-group class="mb-0">
        <b-form-radio-group
          v-model="selected"
          :options="options"
          button-variant="outline-primary"
          size="sm"
          buttons>
        </b-form-radio-group>
      </b-form-group>
    </div>
    <edit-loop-name-modal
      ref="edit-loop-modal"
      @edit-loop-name-modal-closed="emitCloseModal"
    />
    <actions-modal
      ref="actions-modal"
    />
    <settings-stations-modal
      ref="settings-stations-modal"
      @settings-stations-modal-closed="emitCloseSettingsModal"
    />
    <vue-simple-context-menu
      :elementId="'context-menu-settings-' + flux.name"
      :options="contextMenuList"
      :ref="'contextMenuSettingsLoop'"
      @option-clicked="optionClicked"
    />
  </div>
</template>
<script>
import lodash from 'lodash'
import EditLoopNameModal from './EditLoopNameModal.vue'
import ActionsModal from './ActionsModal.vue'
import SettingsStationsModal from './SettingsStationsModal.vue'
import VueSimpleContextMenu from 'vue-simple-context-menu'

export default {
  name: 'LoopData',
  props: ['flux','fluxData'],
  components: {
    'edit-loop-name-modal': EditLoopNameModal,
    'settings-stations-modal' : SettingsStationsModal,
    'vue-simple-context-menu': VueSimpleContextMenu,
    'actions-modal': ActionsModal,
  },
  data() {
    return {
      options: [
        {text: 'Dernière année', value: 'lastYearLeadTime'},
        {text: 'Dernier mois', value: 'lastMonthLeadTime'},
        {text: 'Dernière semaine', value: 'lastWeekLeadTime'}
      ],
      selected: 'lastYearLeadTime',
      contextMenuList: [
        {
        name: 'Gérer les stations de la boucle',
        slug: 'settings',
        class: 'settings',
        },
        {
        name: 'Gérer les actions',
        slug: 'actions',
        class: 'actions',
        }
      ]
    }
  },
  methods: {
    optionClicked (event) {
      const option = event.option.slug
      const loop = this.flux
      if (option === 'settings') {
        this.showSettingsStationsModal(loop)
      } else if (option === 'actions') {
        this.$refs['actions-modal'].showModal(loop)
      }
    },
    handleClick (event, item) {
      if (this.isUserThalesAdmin()) {
        this.$refs.contextMenuSettingsLoop.showMenu(event, item)
      }
    },
    refresh () {
      this.$forceUpdate()
    },
    showSettingsStationsModal (flux) {
      this.$refs['settings-stations-modal'].showModal(flux)
    },
    showEditLoopModal (flux) {
      this.$refs['edit-loop-modal'].showModal(flux)
    },
    emitCloseSettingsModal (loopName) {
      this.$emit('loop-settings-modal-closed')
    },
    emitCloseModal (loopName, newLoopDescription) {
      this.$emit('loop-name-modal-closed', loopName, newLoopDescription)
    },
  },
  watch: { 
  },
};
</script>
<style>

.stats-choice .btn.btn-outline-primary.btn-sm{
  color: var(--a-dark-blue) !important;
  border-color: var(--a-dark-blue) !important;
  margin-right: 0.5rem !important;
  border-radius: 3px !important;
}

.stats-choice .btn.btn-outline-primary.active{
  background-color: var(--a-dark-blue) !important;
  border-color: var(--a-dark-blue) !important;
  color: white !important;
}

.stats-choice .btn.btn-outline-primary:hover{
  background-color: var(--a-dark-blue) !important;
  border-color: var(--a-dark-blue) !important;
  color: white !important;
}

.vue-simple-context-menu__item.settings::before {
  content: '\f013';
  font-family: "FontAwesome";
  margin-right: 0.3rem;
}

.vue-simple-context-menu__item.actions::before {
  content: '\f0e7';
  font-family: "FontAwesome";
  margin-right: 0.3rem;
}

.flux-header div span{
  font-size: 1.3rem;
} 
.flux-header .flux-name{
    font-size: 1.6em; 
    flex-basis: 30%;
    font-weight: 900;
}
.flux-header .flux-name-description{
    font-size: 1.8rem; 
    flex-basis: 30%;
    font-weight: 900;
}

@media (max-width: 992px){
  .flux-name-description{
    text-align: center;
  }
  
}
@media (min-width: 1919px) {
  .stats-choice .btn.btn-outline-primary.btn-sm {
    /* font-size: 1.1rem; */
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoopData.vue